import { useTranslation } from "@refinedev/core";
import { Label } from "components/label";
import { IAttendantTemplateInputItem, SupportedLanguage } from "interfaces";
import { get } from "lodash";

interface IOptionFormProps {
  languages: SupportedLanguage[];
  fieldData: IAttendantTemplateInputItem;
}

export const Options = ({ fieldData, languages }: IOptionFormProps) => {
  const { translate } = useTranslation();
  return (
    <div className="mt-4 bg-magnolia-600 px-5 py-4 -mx-4 sm:-mx-6 -mb-4 rounded-bl-lg rounded-br-lg">
      <p className="text-sm mb-2 font-medium">{translate("eventSetup.participantTemplate.field.optionValue")}</p>
      <div className="grid sm:grid-cols-6 lg:gap-x-6">
        <div className="col-span-full">
          {(fieldData.option ?? []).map((field: any, index: number) => (
            <div
              className={`border rounded-lg mb-4 border-brand-500`}
              key={field.id}
            >
              <div className="bg-magnolia-600 rounded-lg">
                <div className="px-4 py-4 flex flex-col gap-y-4">
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <Label required id={`label_${index}`} name={translate("eventSetup.participantTemplate.field.valueName")} />
                    </div>
                    <div className="flex flex-col gap-y-4">
                      {languages.map((lang: SupportedLanguage) => (
                        <div key={lang}>
                          <div className="relative flex items-center gap-x-2">
                            <img
                              src={`/images/flags/circle-${lang}.png`}
                              alt="Language Icon"
                              className="size-5"
                            />
                            {get(field.label, lang, "")}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <Label required id={`key_${index}`} name="Key" />
                    <div>
                      {field?.key}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
